import React, { useEffect, useState } from "react";
import { getWowStatic } from "hooks/wow/getStaticData";
import WowTooltip from "../../Tooltips/WowTooltip";
import classNames from "classnames";
import { kFormatter } from "../../../lib/tierHelper";
import { ReactComponent as ChevronDown } from "svg/chevron-down.svg";
import { TrinketTable } from "./TrinketsContainer";
import { MediaQuery } from "@outplayed/responsive";

const Trinket = (props) => {
  const { trinket, encounterType, isHealer, onClick, isSelected, trinketPairs } = props;
  const { item_id, count, hps, dps, max_key = 0, quality } = trinket;
  const primaryStat = isHealer ? hps : dps;
  const staticData = getWowStatic("item", item_id);
  const [showPairs, setShowPairs] = useState(true);

  useEffect(() => {
    if (!showPairs && !isSelected) {
      setShowPairs(true);
    }
  }, [isSelected, showPairs]);

  const handleClick = () => {
    onClick(trinket);
    if (isSelected) {
      setShowPairs(!showPairs);
    }
  };

  return staticData ? (
    <div className="trinket-wrapper">
      <div
        className={classNames("grid row", {
          selected: isSelected,
        })}
        onClick={handleClick}
      >
        <div className="trinket-name">
          <WowTooltip type="item" id={item_id}>
            <div className="trinket-img">
              <img src={staticData?.img} alt={staticData?.name} />
            </div>
          </WowTooltip>
          {/* <span style={{ color: getItemQualityColor(quality) }}>{staticData?.name}</span> */}
          <span style={{ color: "rgb(163, 53, 238)" }}>{staticData?.name}</span>
        </div>
        <div className="data-text">{encounterType === "raid" ? kFormatter(primaryStat) : `+${max_key}`}</div>
        <div className="data-text popularity">
          <div>{trinket.perc}%</div>
          <div className="count">({count})</div>
        </div>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail>
          <div className="chevron-container">
            <ChevronDown
              className={classNames("chevron-svg", {
                hide: !showPairs,
              })}
            />
          </div>
        </MediaQuery>
      </div>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail>
        {isSelected && showPairs && (
          <div className="mobile-pairs">
            <TrinketTable trinkets={trinketPairs} selectedTrinket={staticData} encounterType={encounterType} noHeaders pairMode />
          </div>
        )}
      </MediaQuery>
    </div>
  ) : null;
};

export default Trinket;
